export default "__VITE_ASSET__D672B28u__"